import { Box, Typography } from "@mui/material";
import ChatIcon from "@/assets/icons/ChatIcon";
import EmbeddingIcon from "@/assets/icons/EmbeddingIcon";
import ImageGenerationIcon from "@/assets/icons/ImageGenerationIcon";
import LockIcon from "@/assets/icons/LockIcon";
import MultimodalIcon from "@/assets/icons/MultimodalIcon";
import ShareIcon from "@/assets/icons/ShareIcon";
import SpeechToTextIcon from "@/assets/icons/SpeechToTextIcon";
import TextToSpeechIcon from "@/assets/icons/TextToSpeechIcon";
import type { LLMModel, TranslateFn } from "../types";

type ModelVisibilityBadgeProps = {
  model: Pick<LLMModel, "is_public" | "is_shared">;
};

export const ModelVisibilityBadge = ({ model }: ModelVisibilityBadgeProps) => {
  if (model.is_shared) {
    return (
      <Box className="absolute p-1 bottom-[-5px] left-[-5px] rtl:left-auto rtl:right-[-5px] rounded-full border-2 border-[var(--background)] bg-[var(--secondary)]">
        <ShareIcon className="h-2 w-2 text-[var(--secondary-foreground)]" />
      </Box>
    );
  }

  if (!model.is_public) {
    return (
      <Box className="absolute p-1 bottom-[-5px] left-[-5px] rtl:left-auto rtl:right-[-5px] rounded-full border-2 border-[var(--background)] bg-[var(--secondary)]">
        <LockIcon className="h-2 w-2 text-[var(--secondary-foreground)]" />
      </Box>
    );
  }

  return null;
};

type ModelTypeBadgeProps = {
  model: LLMModel;
  t: TranslateFn;
};

export const ModelTypeBadge = ({ model, t }: ModelTypeBadgeProps) => {
  const iconClassName = "text-[var(--secondary-foreground)]";
  const type = model.is_multimodal
    ? { label: t("aiCatalog.multimodal"), Icon: MultimodalIcon }
    : model.is_embedding_model
      ? { label: t("aiCatalog.embeddingModel"), Icon: EmbeddingIcon }
      : model.is_stt_model
        ? { label: t("aiCatalog.speechToText"), Icon: SpeechToTextIcon }
        : model.is_tts_model
          ? { label: t("aiCatalog.textToSpeech"), Icon: TextToSpeechIcon }
          : model.is_image_generation_model
            ? { label: t("aiCatalog.imageGeneration"), Icon: ImageGenerationIcon }
            : { label: t("aiCatalog.chat"), Icon: ChatIcon };

  return (
    <Box className="inline-flex items-center gap-1 px-2 py-1 rounded border border-[var(--border)]">
      <type.Icon className={iconClassName} />
      <Typography className="text-[var(--foreground)] text-center text-xs font-medium">
        {type.label}
      </Typography>
    </Box>
  );
};
